import { FundingPolicyType } from '@shared';
import { WaterlilyClient, createQueryKeys } from '@client/api/waterlily';
import type { CarrierSummary, FormListItem } from '@/features/quote-and-apply-builder';

export interface SaveFormParams {
  formDefinition: PolicyFormDefinition;
  formMetadata: PolicyFormMetadata;
  name: string;
  stateCode?: string;
  fundingPolicyTypeId: FundingPolicyType[];
  dryRun?: boolean;
}

export interface SaveFormResult {
  success: boolean;
  formId: string;
  formName: string;
  message: string;
}

export const formBuilderKeys = createQueryKeys('formBuilder');

export interface SendTestEnvelopeParams {
  submissionData: PolicyFormSubmissionData;
  recipientEmail: string;
  recipientName: string;
}

export interface SendTestEnvelopeResult {
  envelopeId: string;
  roleKeys: string[];
  recipients: { roleKey: string; email: string }[];
}

export const formBuilderApi = {
  getCarrierSummaries: () =>
    WaterlilyClient.get<CarrierSummary[]>('/form-builder-carrier-summaries'),
  getFormsByCarrierId: (insuranceCarrierId: number) =>
    WaterlilyClient.get<FormListItem[]>(`/form-builder-forms/${insuranceCarrierId}`),
  getFormById: (formId: string) => WaterlilyClient.get<PolicyFormConfig>(`/form/${formId}`),
  saveForm: (params: SaveFormParams) =>
    WaterlilyClient.post<SaveFormResult>('/wizard/build-form-with-config', params),
  deleteForm: (formId: string) => WaterlilyClient.delete<{ success: boolean }>(`/form/${formId}`),
  sendTestEnvelope: (formId: string, params: SendTestEnvelopeParams) =>
    WaterlilyClient.post<SendTestEnvelopeResult>(`/wizard/docusign-test-envelope/${formId}`, params),
};
